import { render, staticRenderFns } from "./RobFormModal.vue?vue&type=template&id=543844a8"
import script from "./RobFormModal.vue?vue&type=script&lang=js"
export * from "./RobFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports